import axios from 'axios';
import { JobApplication } from '../redux/jobSlice';

// const API_URL = 'http://localhost:5001/api/applications';
const API_URL = `${process.env.REACT_APP_API_BASE_URL}/api/applications`;

export const addApplication = async (application: JobApplication) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(API_URL, application, {
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': token,
        },
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.error('Server responded with error:', error.response.data);
          throw new Error(error.response.data.message || `Server error: ${error.response.status}`);
        } else if (error.request) {
          // The request was made but no response was received
          console.error('No response received:', error.request);
          throw new Error('No response from server');
        }
      }
      // Something happened in setting up the request that triggered an Error
      console.error('Error setting up request:', error);
      throw new Error('An unexpected error occurred');
    }
  };